var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content", staticStyle: { "margin-top": "13px" } },
        [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticClass: "info" }, [_vm._v("用户信息")]),
            _c(
              "div",
              { staticClass: "info", staticStyle: { "margin-left": "7px" } },
              [_vm._v("/")]
            ),
            _c(
              "div",
              [
                _c(
                  "el-menu",
                  {
                    staticClass: "el-menu-demo",
                    attrs: {
                      "default-active": _vm.activeIndex,
                      mode: "horizontal",
                    },
                    on: { select: _vm.handleSelect },
                  },
                  _vm._l(_vm.btns, function (item, index) {
                    return _c(
                      "el-menu-item",
                      { key: index, attrs: { index: index.toString() } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.currentIndex == 0
            ? _c("userInfo", {
                attrs: { userObject: _vm.userObject },
                on: { getImage: _vm.getImage, getName: _vm.getName },
              })
            : _vm._e(),
          _vm.currentIndex == 1
            ? _c("orderInfo", { attrs: { userId: _vm.userId } })
            : _vm._e(),
          _vm.currentIndex == 2
            ? _c("addressInfo", { attrs: { userId: _vm.userId } })
            : _vm._e(),
          _vm.currentIndex == 3
            ? _c("commissionRecord", { attrs: { userId: _vm.userId } })
            : _vm._e(),
          _vm.currentIndex == 4
            ? _c("fansRecord", { attrs: { userId: _vm.userId } })
            : _vm._e(),
          _vm.currentIndex == 5
            ? _c("cashRecord", { attrs: { userId: _vm.userId } })
            : _vm._e(),
          _vm.currentIndex == 6
            ? _c("couponRecord", { attrs: { userId: _vm.userId } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }